var _style, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascriptPassosProgramacaoOrientadaObjetos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 48 47",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:#444}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcc34f",
    d: "M45.2 10.6l.7 4.9L2.3 31.3 1.8 21v-5.8L39.9 1.4l4.9 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdcf72",
    d: "M44 1.4l2.1 3.1L1.8 20.3 2.9 4.1l2.8-2.7 27.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M17.5 45.2h-12c-1.8 0-3.2-1.5-3.2-3.3V5.1c0-1.8 1.4-3.3 3.2-3.3h36.9c1.8 0 3.2 1.5 3.2 3.3v23.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 7.3,
    r: 1.3,
    className: "st3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8,
    cy: 7.3,
    r: 1.3,
    className: "st3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.4,
    cy: 7.3,
    r: 1.3,
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 38.4l2.3-1.4c.4.8.9 1.5 1.8 1.5s1.5-.4 1.5-1.8V27h2.9v9.7c0 3-1.7 4.3-4.3 4.3-2.2 0-3.5-1.1-4.2-2.6zm10.1-.3l2.3-1.3c.6 1 1.4 1.7 2.8 1.7 1.2 0 1.9-.6 1.9-1.4 0-1-.8-1.3-2.1-1.9l-.7-.3c-2.1-.9-3.4-2-3.4-4.3 0-2.1 1.6-3.8 4.2-3.8 1.8 0 3.1.6 4.1 2.3l-2.2 1.4c-.5-.9-1-1.2-1.8-1.2s-1.4.5-1.4 1.2c0 .9.5 1.2 1.8 1.7l.7.3c2.4 1 3.8 2.1 3.8 4.5 0 2.6-2 4-4.7 4-2.8 0-4.5-1.2-5.3-2.9zM42.6 33l-1.9 7.5H39l1.9-7h-1.5v1.3h-1.6V32h4.9v1z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.7,
    cy: 39.9,
    r: 0.6,
    className: "st3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptPassosProgramacaoOrientadaObjetos);
export default __webpack_public_path__ + "static/media/javascript-passos-programacao-orientada-objetos.186903c153857b82958cd994b523a02c.svg";
export { ForwardRef as ReactComponent };